module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question"
  }, [(_vm.$mobile && _vm.questionToggle != null) ? _c('aside', {
    staticClass: "questionToggle",
    class: {
      'toggled': _vm.questionToggle
    },
    on: {
      "click": _vm.toggleQuestion
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    on: {
      "enter": _vm.slideinQuestion,
      "leave": _vm.slideoutQuestion
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$mobile && _vm.questionToggle === true || _vm.questionToggle != false),
      expression: "$mobile && questionToggle === true || questionToggle != false"
    }],
    staticClass: "introtext-container",
    class: {
      'floating': _vm.$mobile && _vm.questionToggle != null, 'mobile': _vm.$mobile
    }
  }, [_c('div', {
    staticClass: "introtext",
    domProps: {
      "innerHTML": _vm._s(_vm.episode.introtext)
    },
    on: {
      "click": _vm.setupQuestionToggle
    }
  })])]), _vm._v(" "), (!_vm.$mobile) ? _c('Answers', {
    attrs: {
      "type": 'compact',
      "mod": 0
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadein"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$mobile && _vm.questionToggle != null || !_vm.$mobile),
      expression: "$mobile && questionToggle != null || !$mobile"
    }],
    staticClass: "question-container",
    class: {
      'inline': _vm.showFeedback, 'mobile': _vm.$mobile
    }
  }, [(_vm.action) ? _c('div', {
    staticClass: "question-box"
  }, [_c('div', {
    staticClass: "question-action-header"
  }, [_vm._v("\n                    actie " + _vm._s(_vm.action.id + 1) + " / " + _vm._s(_vm.total) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "question-action-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.action.title) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "question-action-answers"
  }, [_c('div', {
    staticClass: "answer answer-left",
    class: {
      'active': _vm.answer === false
    },
    on: {
      "click": function($event) {
        _vm.processAction(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.false))]), _vm._v(" "), _c('div', {
    staticClass: "answer answer-right",
    class: {
      'active': _vm.answer
    },
    on: {
      "click": function($event) {
        _vm.processAction(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.true))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFeedback),
      expression: "showFeedback"
    }],
    staticClass: "feedback-container",
    class: {
      'correct': _vm.correct, 'mobile': _vm.$mobile
    }
  }, [(_vm.action) ? _c('div', {
    staticClass: "feedback"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                " + _vm._s((_vm.correct) ? 'Goede' : 'Verkeerde') + " beslissing!\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "feedback-text"
  }, [_vm._v("\n                " + _vm._s(_vm.action.feedback) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [(!_vm.$mobile) ? _c('span', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.nextAction
    }
  }, [_vm._v(" OK")]), _vm._v(" "), _c('br'), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$mobile || _vm.$mobile && _vm.questionToggle != null),
      expression: "!$mobile || $mobile && questionToggle != null"
    }],
    staticClass: "points-container",
    class: {
      'mobile': _vm.$mobile
    }
  }, [_vm._m(0), _vm._v("\n        " + _vm._s(_vm.points)), _c('span', [_vm._v(" punten")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "explosion-container"
  }, [_c('div', {
    staticClass: "anim-container"
  }, [_c('div', {
    staticClass: "glow"
  }), _vm._v(" "), _c('div', {
    staticClass: "bolts"
  }, [_c('img', {
    staticClass: "bolt bolt1",
    attrs: {
      "src": require("../assets/bolt.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "bolt bolt2",
    attrs: {
      "src": require("../assets/bolt.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "bolt bolt3",
    attrs: {
      "src": require("../assets/bolt.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "bolt bolt4",
    attrs: {
      "src": require("../assets/bolt.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "bolt bolt5",
    attrs: {
      "src": require("../assets/bolt.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "halos"
  }, [_c('img', {
    staticClass: "halo halo1",
    attrs: {
      "src": require("../assets/halo.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "halo halo2",
    attrs: {
      "src": require("../assets/halo.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "halo halo3",
    attrs: {
      "src": require("../assets/halo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bricks"
  }, [_c('img', {
    staticClass: "brick brick1",
    attrs: {
      "src": require("../assets/brick-small.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "brick brick2",
    attrs: {
      "src": require("../assets/brick-large.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52743617!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Question.vue
// module id = 118
// module chunks = 1